export const tabLabels = [
  'Passerby',
  'Dwell',
  'Loyalties',
  'Weather',
  'Air Quality',
  'Combined',
]
